import { render } from "./App.vue?vue&type=template&id=47816aee"
const script = {}

import "./App.vue?vue&type=style&index=0&id=47816aee&lang=scss"

import exportComponent from "/Users/a123/Desktop/代码/易考通相关项目/证书查询/zs-query/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__